import { useEffect, useState } from 'react'

import { useGetFieldValueAddressFromApi } from './fieldValueAddress'

export const useGetServiceOrderAddress = serviceOrder => {
  const [getPlaceAddress, { loading }] = useGetFieldValueAddressFromApi()
  const [address, setAddress] = useState(serviceOrder?.address)

  useEffect(() => {
    if (!address) getPlaceAddress(serviceOrder?.place?.id, serviceOrder?.place?.type).then(setAddress)
  }, [])

  return [address, loading]
}
